import React, { useState, useEffect } from "react";

const BLOG_ARTICLES = [
  { id: "careers-after-10th", title: "Best Careers After 10th Standard", badge: "🔥 Trending" },
  { id: "engineering-vs-ca-vs-medical", title: "Engineering vs CA vs Medical", badge: "⭐ New" },
  { id: "when-to-switch-jobs", title: "When to Switch Jobs — Signs & Strategies", badge: "📈 Popular" },
];

export default function BlogToast({ onBlogOpen }) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [articleIndex, setArticleIndex] = useState(0);

  useEffect(() => {
    // Pick a random article
    setArticleIndex(Math.floor(Math.random() * BLOG_ARTICLES.length));

    const handleScroll = () => {
      if (dismissed) return;
      const scrollPercent = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
      if (scrollPercent > 40 && !visible) {
        setVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dismissed, visible]);

  // Auto-hide after 8 seconds
  useEffect(() => {
    if (visible && !dismissed) {
      const timer = setTimeout(() => setDismissed(true), 8000);
      return () => clearTimeout(timer);
    }
  }, [visible, dismissed]);

  if (!visible || dismissed) return null;

  const article = BLOG_ARTICLES[articleIndex];

  return (
    <div 
      className="fixed bottom-6 left-6 z-50 max-w-xs"
      style={{ animation: "slideInLeft 0.5s ease-out forwards" }}
    >
      <style>{`
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-100%); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
        {/* Gradient bar */}
        <div className="h-1.5 w-full bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500" />
        
        <div className="p-4">
          <div className="flex items-start justify-between gap-2">
            <div>
              <span className="text-xs font-bold text-red-500">{article.badge}</span>
              <p className="font-semibold text-gray-900 text-sm mt-1 leading-snug">{article.title}</p>
            </div>
            <button
              onClick={() => setDismissed(true)}
              className="text-gray-400 hover:text-gray-600 text-lg leading-none shrink-0 mt-0.5"
              aria-label="Close"
            >
              ✕
            </button>
          </div>
          <button
            onClick={() => {
              onBlogOpen(article.id);
              setDismissed(true);
            }}
            className="mt-3 w-full text-center text-sm font-semibold text-white bg-gradient-to-r from-indigo-500 to-purple-500 rounded-lg py-2 hover:from-indigo-600 hover:to-purple-600 transition-all"
          >
            Read Now →
          </button>
        </div>
      </div>
    </div>
  );
}
